import { ColumnsType, Progress } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { NoData } from 'views/components/NoData/NoData'
import { ATableFullPageWithoutData } from 'views/components/Table/ATableFullPageWithoutData'
import { DashboardTabItemProps } from '../types'

type Props = DashboardTabItemProps & {
  useColumns: () => ColumnsType
  rowClassName?: () => string
}

export const DashboardList: FC<Props> = (props) => {
  const { progress, data, total, useColumns, rowClassName } = props

  const columns = useColumns()

  return !data?.length && !total && (progress === Progress.SUCCESS || progress === Progress.ERROR) ? (
    <NoData />
  ) : (
    <ATableFullPageWithoutData columns={columns} {...props} rowHoverGray rowClassName={rowClassName} />
  )
}
